import React, { Component } from "react";

import Button from "../Button";
import {connect} from "react-redux";

import * as googleAuthActions from '../../../actions/googleAuth';

import styles from './styles.scss';
import Input from "../Input";
import {Field} from "redux-form";
import AlertBox from "../AlertBox";

class AppSetup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            googleCode: null
        }

        this._preventSubmit = this._preventSubmit.bind(this);
        this._verifyOTP = this._verifyOTP.bind(this);
    }

    componentDidMount() {
        this.props.resetQrCode();
        this.props.clearErrors();
        this.props.generateQrCode(this.props.userId);
    }

    _verifyOTP() {
        return this.props.confirmSetup(this.state.googleCode)
            .then( () => {
                if (this.props.otpVerified === true) this.props.onCompleteSetup()
            });
    }

    _preventSubmit(e){
        if(e.keyCode === 13){
            e.preventDefault();
            this._verifyOTP();
        }
    }

    render() {
        if (!this.props.show) return null;

        return (
            <div className={styles['setup--box']}>
                {this.props.qrCode && !this.props.isGeneratingQrCode &&
                    <div className={styles['setup--box_container']}>
                        <div className={styles['setup--details']}>
                            <p>
                                To set up Google Authenticator, launch the app and click the (+) in the bottom corner. You can then scan
                                the following QR code, which will generate a 6 digit code in the Google Authenticator app. Enter the code into the box below and click
                                Verify.
                            </p>
                            <p>
                                Alternatively, use the code <strong>{this.props.googleSecret}</strong> in Google Authenticator if you are unable to scan the QR code.
                            </p>
                        </div>
                        <div className={styles['setup--qr-code']}>
                            <div dangerouslySetInnerHTML={{__html: this.props.qrCode}}/>
                        </div>
                        <div className={styles['setup--actions']}>
                            <Field
                                name="one_time_password"
                                component={Input}
                                type="text"
                                label="Enter generated code"
                                onChange={e => this.setState({googleCode: e.target.value})}
                                onKeyDown={e => this._preventSubmit(e)}
                                autoFocus
                                meta={{ error: this.props.errors.verify_code, touched: ('verify_code' in this.props.errors) }}
                            />
                            <Button type="button" onClick={this._verifyOTP}>
                                Verify
                            </Button>
                        </div>
                    </div>
                }
                {this.props.qrCodeGenerateError && !this.props.isGeneratingQrCode &&
                    <div className={styles['setup--box_container']}>
                        <AlertBox role="alert" theme="danger">Sorry, an error occurred and the setup could not complete. Please try again.</AlertBox>
                    </div>
                }
                <br />
                <div className={styles['setup--cancel_button']}>
                    <Button type="button" theme="cancel" onClick={ this.props.onClickClose }>Cancel App Setup</Button>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ...state.googleAuth
    }
}

function mapDispatchToProps(dispatch) {
    return {
        resetQrCode() {
            dispatch(googleAuthActions.resetQrCode());
        },
        generateQrCode(userId) {
            return dispatch(googleAuthActions.generateAppQrCode(userId));
        },
        confirmSetup(code) {
            return dispatch(googleAuthActions.confirmSetup(code));
        },
        clearErrors() {
            dispatch(googleAuthActions.clearErrors());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppSetup);